/** @format */

import axios from "axios";
import swal from "sweetalert";
import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";

import { header } from "../../../../components/api/Header";
import { user_data } from "../../../../components/functions/usr";
import { getEnv } from "../../../../lib/env";

function Add({ date, setDate }) {
  const [data, setData] = useState("");
  const [ldate, setLdate] = useState(date);
  const [changed, setChanged] = useState(false);

  const keyDown = (e) => {
    if (e.key === "Enter") {
      const fields = Array.from(document.querySelectorAll("input")) || [];
      const position = fields.indexOf(e.target);
      fields[position + 1] && fields[position + 1].focus();
      if (position == fields.length - 1) {
        fields[2].focus();
      }
    }
  };

  if (user_data()) {
    if (user_data().region_id == 9 || user_data().region_id == 16) {
    } else {
      window.location = "/oqjarqizilqishloq";
    }
  } else {
    window.location = "/oqjarqizilqishloq";
  }

  useEffect(() => {
    const fetchDate = async () => {
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/region/oqjar/daily?date=${date}`,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.error("Xato", e);
        alert("Server bilan aloqa yo'q");
      }
    };
    if (date) {
      fetchDate();
    }
  }, [date]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  const doIt = async (action) => {
    try {
      const res = await axios.post(
        `${getEnv('REACT_APP_BASE_URL')}/v1/region/oqjar/${action}`,
        { date, data },
        header()
      );
      if (res.data.status === 200) {
        swal("Muvaffaqiyatli", res.data.message, "success");
        setDate("");
        window.location = "/oqjarqizilqishloq";
      } else {
        swal("Xato", res.data.message, "error");
      }
    } catch (e) {
      console.error("Xato", e);
      alert("Server bilan aloqa yo'q!");
    }
  };

  const deletehandler = () => {
    let xa = window.confirm(
      date + " dagi ma'lumotlarni o'chirishni xoxlaysizmi?"
    );
    if (xa) {
      doIt("delete");
    }
  };

  const setHandler = (v, t) => {
    let d = { ...data };
    d[t] = v;
    setChanged(true);
    setData(d);
  };

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <ul className='list-unstyled list-inline'>
            <li className='list-inline-item'>
              <NavLink
                to='/oqjarqizilqishloq'
                className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                <ArrowLeftOutlined />
                &nbsp;&nbsp;&nbsp;Qaytish
              </NavLink>
            </li>

            <li className='list-inline-item'>
              {data ? (
                data["id"] != 0 ? (
                  <NavLink
                    to='/oqjarqizilqishloq'
                    className='btn btn-sm btn-outline-danger d-flex align-items-center'
                    onClick={() => deletehandler()}>
                    O'chirish&nbsp;&nbsp;&nbsp;
                    <DeleteOutlined />
                  </NavLink>
                ) : null
              ) : null}
            </li>

            <li className='list-inline-item'>
              <div className='d-flex'>
                <input
                  type='date'
                  className='form-control-sm form-control'
                  onChange={(e) => setLdate(e.target.value)}
                  value={ldate}
                />
              </div>
            </li>

            <li className='list-inline-item'>
              {date ? null : " <--Sanani tanlang"}
            </li>
          </ul>
        </div>
      </div>

      <div className='table-responsive tableFixHead'>
        <table className='table table-bordered table-style' id='tblData'>
          <thead>
            <tr>
              <th rowSpan={2} scope='col'>
                Oqjar
              </th>

              <th rowSpan={2} scope='col'>
                Qizil qishloq
              </th>

              <th rowSpan={2} scope='col'>
                Reyka №1
              </th>

              <th rowSpan={2} scope='col'>
                Reyka №5
              </th>

              <th colSpan={2} scope='col'>
                Tojikiston
              </th>

              <th colSpan={2} scope='col'>
                Toshkent viloyati
              </th>

              <th rowSpan={2} scope='col'>
                JMMK
              </th>

              <th rowSpan={2} scope='col'>
                Do’stlik kanali
              </th>

              <th colSpan={2} scope='col'>
                Shundan
              </th>
            </tr>

            <tr>
              <th scope='col'>NS zafar quy. Qayr</th>
              <th scope='col'>YUDK</th>
              <th scope='col'>QDK</th>
              <th scope='col'>Bekobod</th>
              <th scope='col'>O’zbekiston</th>
              <th scope='col'>Qozog’iston</th>
            </tr>
          </thead>

          {date ? (
            <tbody>
              <tr>
                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.oqjar1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "oqjar1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.qizil1}
                    id='test'
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "qizil1")}
                  />
                </th>

                <th
                  className='text-center inserttr'
                  rowSpan={2}
                  style={{ verticalAlign: "middle" }}>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.reka1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "reka1")}
                  />
                </th>

                <th
                  className='text-center inserttr'
                  rowSpan={2}
                  style={{ verticalAlign: "middle" }}>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.reka5}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "reka5")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.ns}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "ns")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.yudk1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "yudk1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.kdk1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "kdk1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.bekobod1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "bekobod1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.jmmk1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "jmmk1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.dostlik1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "dostlik1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.uzb1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "uzb1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.kz1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "kz1")}
                  />
                </th>
              </tr>

              <tr>
                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.oqjar2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "oqjar2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.qizil2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "qizil2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.ns1}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "ns1")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.yudk2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "yudk2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.kdk2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "kdk2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.bekobod2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "bekobod2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.jmmk2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "jmmk2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.dostlik2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "dostlik2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.uzb2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "uzb2")}
                  />
                </th>

                <th className='text-center inserttr'>
                  <input
                    onKeyDown={keyDown}
                    type='number'
                    value={data.kz2}
                    className='insertable'
                    onChange={(e) => setHandler(e.target.value, "kz2")}
                  />
                </th>
              </tr>
            </tbody>
          ) : null}
        </table>

        {changed ? (
          <button
            className='btn btn-primary btn-sm'
            onClick={() => doIt("save")}>
            Saqlash
          </button>
        ) : null}
      </div>
    </>
  );
}

export default Add;
